import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Pomelo from '@/components/Pomelo'
import Partner from '@/components/Partner'
import Course from '@/components/Course'
import Case from '@/components/Case'
import Agent from '@/components/Agent'
import AboutUs from '@/components/AboutUs'
import Help from '@/components/Help'
import DownLoad from '@/components/DownLoad'

import Product from '@/page/product'

import {Pagination} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Router)
Vue.use(Pagination)

let router = new Router({
	mode: 'history',
	routes: [
		{
		  path: '/',
		  name: 'index',
		  component: Index,
			meta: {
				title: `KA儿童之家 - 幼教互联网平台_覆盖幼儿园/教师/家长`,
				keywords: `KA儿童之家,幼教互联网,伊顿`
			}
		},
		{
		  path: '/pomelo',
		  meta: {
		  	title: `柚子通_幼儿园/教师/家长三端_互联网产品 - KA儿童之家`,
		  	keywords: `互联网产品,柚子通,三端`
		  },
		  component: Product,
			children: [
				{
					path: '/',
					name: 'pomelo',
					component: Pomelo
				},
				{
					path: '/kindergarten', 
					name: '园所端',
					component: resolve => require(['@/components/Pomelo/Kindergarten'], resolve),
					meta: {
						title: `柚子通_轻松打造高品质幼儿园 - KA儿童之家`,
						keywords: `园所端,柚子通,营养膳食`
					}
				},
				{
					path: '/teacher', 
					name: '教师端',
					component: resolve => require(['@/components/Pomelo/Teacher'], resolve),
					meta: {
						title: `柚子通_幼师专业成长平台 - KA儿童之家`,
						keywords: `教师端,柚子通,幼师成长`
					}
				},
				{
					path: '/parents', 
					name: '家长端',
					component: resolve => require(['@/components/Pomelo/Parents'], resolve),
					meta: {
						title: `柚子通_帮家长辅助孩子成长 - KA儿童之家`,
						keywords: `家长端,柚子通,家长大学`
					}
				},
			]
		},
		{
		  path: '/partner',
		  name: 'partner',
		  component: Partner,
			meta: {
				title: `幼教合伙人_专业的一站式合伙人平台 - KA儿童之家`,
				keywords: `幼教合伙人,高端园,示范园`
			}
		},
		{
		  path: '/course',
		  name: 'course',
		  component: Course,
			meta: {
				title: `特色课程_高品质有特色的高端课程体系 - KA儿童之家`,
				keywords: `特色课程,蒙台梭利,教育理念`
			}
		},
		{
		  path: '/case',
		  name: 'case',
		  component: Case,
			meta: {
				title: `合作案例_幼儿园整体解决方案 - KA儿童之家`,
				keywords: `合作案例,中高端园,运营管理`
			}
		},
		{
		  path: '/agent',
		  name: 'agent',
		  component: Agent,
			meta: {
				title: `代理合作_区域代理加盟合作 - KA儿童之家`,
				keywords: `代理合作,代理商,零门槛`
			}
		},
		{
		  path: '/aboutus',
		  name: 'aboutus',
		  component: AboutUs,
			meta: {
				title: `关于我们_覆盖幼儿园/教师/家长_赋能幼教 - KA儿童之家`,
				keywords: `KA儿童之家,品牌故事,教育理念`
			}
		},
		{
		  path: '/help',
		  name: 'help',
		  component: Help,
			meta: {
				title: `帮助中心 - KA儿童之家`,
				keywords: `帮助中心,柚子通,产品`
			}
		},
		{
		  path: '/download',
		  name: 'download',
		  component: DownLoad,
			meta: {
				title: `下载APP_柚子通_幼儿园/教师/家长三端 - KA儿童之家`,
				keywords: `下载APP,柚子通,互联网产品`
			}
		},
		{
		  path: '/news',
		  name: '新闻资讯',
		  component: resolve => require(['@/components/News/News'], resolve),
			meta: {
				title: `新闻资讯_覆盖幼儿园/教师/家长_赋能幼教 - KA儿童之家`,
				keywords: `新闻资讯,KA儿童之家,幼教`
			},
			children: [
			]
		},
		{
		  path: '/news/:id',
		  name: '新闻资讯详情',
		  component: resolve => require(['@/components/News/NewsDetails'], resolve),
			meta: {
				title: `新闻资讯_覆盖幼儿园/教师/家长_赋能幼教 - KA儿童之家`,
				keywords: `KA儿童之家,幼教,互联网`,
			}
		},
	]
})
router.beforeEach((to, from, next) => {
	if(to.meta.title) {
		document.title = to.meta.title
		document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
		document.querySelector('meta[name="description"]').setAttribute('content', 'KA儿童之家是提供系统性解决方案的幼教互联网平台，通过幼教合伙人、特色课程、柚子通等产品全面赋能幼儿园、教师、家长三端，将优质教育带给更多孩子。') 
	}
	next()
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js